import React from "react";
import TextInfo from "@/bit/components/next13.components.text";
import CustomLink from "@/bit/components/next13.components.custom-link";

export const SCX_PATH = `https://{env}.cms.col.movistar.es/static/js/scx/scx.js`;

function C2CModule({ textLink }) {
  const taggingInfoC2C = {
    componentName: "buy-box",
    componentVariation: "all",
    componentContent: "Te llamamos",
    componentProduct: "",
    eventType: "click",
  };

  const handleClick = () => {
    let loadjs = null;
    let env = "prod";
    if (`${process.env.NEXT_PUBLIC_ENV_NAME}` !== env) {
      env = "qa";
    }
    const scxRoute = SCX_PATH.replace("{env}", env);
    import("loadjs").then((module) => {
      loadjs = module.default;
      if (window && !window.SCX) {
        loadjs(scxRoute, { async: true, returnPromise: true }).then(() => {
          window.SCX.setReactEnviroment();
          window.SCX.launchModalC2C();
        });
      }
      if (window && window.SCX) {
        window.SCX.launchModalC2C();
      }
    });
  };

  return (
    <>
      <div className="container-C2C">
        <TextInfo {...textLink} cyData="SimplePhone Text C2C" />
        <CustomLink
          onClick={handleClick}
          taggingInfo={taggingInfoC2C}
          cyData="SimplePhone Text C2C"
        >
          <TextInfo text="te llamamos." size="caption02" color="blue_a" />
        </CustomLink>
      </div>
    </>
  );
}

export default C2CModule;
